import { uniqBy } from "lodash-es";

import { useCreateDatasetFromScratchMutation } from "src/datasets/api/queries";
import { DEFAULT_DATASET_NAME } from "src/datasets/constants";
import { useAvailableIntegrationNodes } from "src/datasets/DatasetTable/hooks";
import { getDesiredType } from "src/datasets/DatasetTable/utils";
import { useInputColumnsFromSchema } from "src/datasets/utils";
import { TAKTILE_TEAM_NOTIFIED } from "src/design-system/Toast/constants";
import { toastActions } from "src/design-system/Toast/utils";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { useSetEditDatasetId } from "src/router/SearchParams";

export const useCreateDatasetFromScratch = () => {
  const { workspace, flow, version } = useAuthoringContext();
  const setEditDatasetId = useSetEditDatasetId();
  const integrationNodes = useAvailableIntegrationNodes(version);
  const inputColumns = useInputColumnsFromSchema(version);

  const createDataset = useCreateDatasetFromScratchMutation(
    workspace?.base_url,
  );

  return async () => {
    try {
      const dataset = await createDataset.mutateAsync({
        name: DEFAULT_DATASET_NAME,
        flow_id: flow.id,
        input_columns: inputColumns,
        mock_columns: uniqBy(integrationNodes, "name").map((node) => ({
          name: node.name,
          desired_type: getDesiredType(node),
          use_subflow_mocks: false,
        })),
        purpose: "test_run",
      });

      setEditDatasetId(dataset.id);
    } catch {
      toastActions.failure({
        title: "Dataset creation failed",
        description: TAKTILE_TEAM_NOTIFIED,
      });
    }
  };
};
